// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"e991f979","226":"ee697b3e","230":"0e6bca8c","316":"db30820c","411":"4a24a239","584":"78009178","586":"96311999","704":"1a65efca","924":"e8e4cf51","974":"ee5e6fec","981":"cec9b856"}[chunkId] + ".chunk.js";
};